<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="积分明细"
      width="800px"
      @close="close"
    >
      <template #footer>
        <el-button @click="close">关 闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findScoreRecordList } from '@/api/game'
import moment from 'moment'
export default {
  name: 'ScoreDetail',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      moment,
      list: [],
      gameList: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        gameId: '',
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    show(row, gameId) {
      this.queryForm.gameId = gameId
      this.getGameList()
      this.dialogFormVisible = true
    },
    //获取游戏列表
    async getGameList() {
      const { list } = await findList({ page: 1, size: 10000 })
      this.gameList = list
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
</style>
